import { PayloadAction } from '@reduxjs/toolkit';
import createAppSlice from 'app/createAppSlice';
import { IPublicRecordsSlice } from './types';

const initialState: IPublicRecordsSlice = {
  properties: null,
};

const publicRecordsSlice = createAppSlice({
  name: 'publicRecords',
  initialState,
  reducers: {
    setPublicRecordProperties(
      state,
      action: PayloadAction<IPublicRecordsSlice['properties']>,
    ) {
      state.properties = action.payload;
    },
  },
});

export const { setPublicRecordProperties } = publicRecordsSlice.actions;
export default publicRecordsSlice.reducer;
